import {DomainEvent} from "@platform/event-bus/domain/model/domain-event.model";

export class BookingExitedEvent implements DomainEvent {
  readonly occurredAt = new Date();
}
